export enum MATERIAL_UI_VARIANTS {
  OUTLINED = 'outlined',
  STANDARD = 'standard',
  FILLED = 'filled'
}
